@if (data?.content?.cards?.length) {
  <div class="container max-width">
    @for (item of data.content.cards; track item) {
      <app-equity-card-item
        [card]="item"
        [small]="data?.options?.small"></app-equity-card-item>
    }
  </div>
}
